export default function Problem() {
    const points = [
        ["01", "AI Slop is flooding the feed", "Generic, soulless content has lost the trust of audiences and algorithms alike."],
        ["02", "Digital Noise is at all-time highs", "Paid distribution alone no longer cuts through. Attention costs more, returns less."],
        ["03", "Traditional PR is opaque", "Vanity placements, no measurable ROI, and zero compounding reputation capital."],
    ];
    return (
        <section
            id="problem"
            data-testid="problem-section"
            className="relative py-28 md:py-40"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-10">
                <div className="grid md:grid-cols-12 gap-10">
                    <div className="md:col-span-5 reveal">
                        <div className="text-[11px] uppercase tracking-[0.3em] text-[#e6192b] mb-6">
                            ⎯⎯ The Manifesto · §01
                        </div>
                        <h2 className="font-serif-display text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight text-balance">
                            Marketing,{" "}
                            <span className="italic text-[#a0a0ab]">
                                as you know it,
                            </span>{" "}
                            is{" "}
                            <span className="text-[#e6192b] italic">
                                broken
                            </span>
                            .
                        </h2>
                        <p className="mt-8 text-[#a0a0ab] text-base leading-relaxed max-w-md">
                            Brands are drowning in synthetic content and
                            shrinking margins. The old playbook — buy
                            impressions, hope for clicks — collapses the moment
                            the consumer&apos;s first question is asked to a
                            language model.
                        </p>
                    </div>

                    <div className="md:col-span-7 md:pl-12 md:border-l border-[#26262a]">
                        <div className="space-y-12">
                            {points.map(([num, h, body], i) => (
                                <div
                                    key={num}
                                    data-testid={`problem-point-${i}`}
                                    className="grid grid-cols-12 gap-6 reveal"
                                    style={{ transitionDelay: `${i * 80}ms` }}
                                >
                                    <div className="col-span-2 md:col-span-1 font-serif-display italic text-3xl text-[#e6192b]">
                                        {num}
                                    </div>
                                    <div className="col-span-10 md:col-span-11">
                                        <h3 className="font-serif-display text-2xl md:text-3xl mb-3 leading-tight">
                                            {h}
                                        </h3>
                                        <p className="text-[#a0a0ab] leading-relaxed">
                                            {body}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
